import * as ROUTES from '../constants/routes';

const FRANCHISEE_EMAIL_DOMAIN = 'douglasmccartney.com';

const normalizeEmail = (email) => {
  if (typeof email !== 'string') {
    return '';
  }
  return email.trim().toLowerCase();
};

export const isFranchiseeEmail = (email) => {
  const normalized = normalizeEmail(email);
  if (!normalized) {
    return false;
  }
  const atIndex = normalized.lastIndexOf('@');
  if (atIndex === -1) {
    return false;
  }
  const domain = normalized.slice(atIndex + 1);
  return domain === FRANCHISEE_EMAIL_DOMAIN;
};

export const getDashboardRouteForEmail = (email) => (
  isFranchiseeEmail(email) ? ROUTES.FRANCHISE_DASHBOARD : ROUTES.DASHBOARD
);
